import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MapPin, Sparkles, Send } from "lucide-react";
import { getMarketplace, sendProposal, perr } from "../lib/api";

const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

function RequestCard({ r, onSent }) {
  const [amount, setAmount] = useState("");
  const [message, setMessage] = useState("");
  const [samagri, setSamagri] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    if (!amount) return toast.error("Enter your proposal amount");
    setBusy(true);
    try {
      await sendProposal({ request_id: r.id, amount: Number(amount), message, includes_samagri: samagri });
      toast.success("Proposal sent to the customer");
      onSent(r.id);
    } catch (e) { toast.error(perr(e, "Could not send proposal")); }
    finally { setBusy(false); }
  };
  return (
    <div data-testid={`market-req-${r.id}`} className="rounded-2xl border border-[#Eee3d6] bg-white p-5">
      <div className="flex items-start justify-between">
        <div><h3 className="font-heading text-lg font-semibold">{r.pooja_name}</h3>
          <p className="mt-0.5 text-xs text-[#8A8072]">{r.date} · {r.time}</p></div>
        <span className="flex items-center gap-1 rounded-full bg-[#F4E4E6] px-2 py-0.5 text-[10px] font-bold text-[#8B1A2B]"><Sparkles size={11} /> AI REVIEWED</span>
      </div>
      <p className="mt-3 flex items-start gap-1.5 text-sm font-medium"><MapPin size={15} className="mt-0.5 text-[#8B1A2B]" /> <span>{r.address}{r.landmark ? <span className="block text-xs text-[#8A8072]">{r.landmark}</span> : null}</span></p>
      {(r.budget_min || r.budget_max) && <p className="mt-2 text-sm font-semibold">Customer budget {inr(r.budget_min)} – {inr(r.budget_max)}</p>}
      {r.note && <p className="mt-1 text-sm text-[#7A6E64]">{r.note}</p>}
      {r.proposed ? (
        <p className="mt-4 rounded-xl bg-[#E9F5EC] py-2.5 text-center text-sm font-semibold text-[#2E7D46]">Proposal sent ✓</p>
      ) : (
        <div className="mt-4 space-y-2">
          <input data-testid={`market-amount-${r.id}`} value={amount} onChange={(e) => setAmount(e.target.value.replace(/[^0-9]/g, ""))} inputMode="numeric" placeholder="Your proposal amount"
            className="w-full rounded-xl border border-[#E7DECF] bg-[#FBF7F1] px-3.5 py-3 text-sm outline-none focus:border-[#8B1A2B]" />
          <textarea value={message} onChange={(e) => setMessage(e.target.value)} rows={2} placeholder="Message to customer: timing, samagri, tradition…"
            className="w-full rounded-xl border border-[#E7DECF] bg-[#FBF7F1] px-3.5 py-3 text-sm outline-none focus:border-[#8B1A2B]" />
          <label className="flex items-center gap-2 text-sm text-[#5C5449]">
            <input type="checkbox" checked={samagri} onChange={(e) => setSamagri(e.target.checked)} className="h-4 w-4 accent-[#8B1A2B]" /> My proposal includes samagri
          </label>
          <button data-testid={`market-send-${r.id}`} disabled={busy} onClick={submit}
            className="flex w-full items-center justify-center gap-2 rounded-xl bg-[#8B1A2B] py-3 text-sm font-semibold text-white hover:bg-[#6F1420] disabled:opacity-60">
            {busy ? "Sending…" : "Send proposal"} <Send size={15} />
          </button>
        </div>
      )}
    </div>
  );
}

export default function PriestRequests() {
  const [d, setD] = useState(null);
  const load = () => getMarketplace().then(setD).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!d) return <p className="text-sm text-[#7A6E64]">Loading requests…</p>;
  return (
    <div data-testid="priest-marketplace" className="space-y-5">
      <div>
        <p className="text-xs font-bold uppercase tracking-widest text-[#C6603A]">Ceremony marketplace</p>
        <h1 className="mt-1 font-heading text-3xl font-bold">Requests that match your practice.</h1>
        <p className="mt-1 text-sm text-[#7A6E64]">Review the exact address, then send your price proposal.</p>
      </div>
      <div className="flex gap-6 border-y border-[#F0E8DC] py-3">
        <div><p className="font-heading text-2xl font-bold">{d.count}</p><p className="text-xs text-[#8A8072]">Matching requests</p></div>
        <div className="border-l border-[#F0E8DC] pl-6"><p className="font-heading text-lg font-bold">{d.area}</p><p className="text-xs text-[#8A8072]">Current service area</p></div>
      </div>
      {d.requests.length === 0 ? <p className="py-10 text-center text-sm text-[#7A6E64]">No open requests right now.</p>
        : <div className="space-y-4">{d.requests.map((r) => <RequestCard key={r.id} r={r} onSent={load} />)}</div>}
    </div>
  );
}
